// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.mega-menu-category-dropdown{position:relative;z-index:var(--dropdown-z-index)}.mega-menu-category-dropdown__category-dropdown_sub{z-index:calc(var(--dropdown-z-index) + 1);--menu-dropdown-item-hover-background:var(--c-light-1);--menu-dropdown-item-hover-color:var(--c-primary)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
